import { render, staticRenderFns } from "./LoginConnect.vue?vue&type=template&id=284e1504&"
import script from "./LoginConnect.vue?vue&type=script&lang=js&"
export * from "./LoginConnect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports